import { render, staticRenderFns } from "./ProdictConfigList.vue?vue&type=template&id=3b2dbae6&scoped=true"
import script from "./ProdictConfigList.vue?vue&type=script&lang=js"
export * from "./ProdictConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2dbae6",
  null
  
)

export default component.exports